export default __webpack_public_path__ + "static/media/noKT.da8ae449.png";